import {
  STORE_ANALYSIS_RESULT,
  CLEAR_ANALYSIS_RESULT,
  ANALYSIS_STRING_ERROR,
  CLEAR_ANALYSIS_STRING_ERROR,
  SHOW_ANALYSIS_LOADING,
  HIDE_ANALYSIS_LOADING,
} from "../actions/types"

const INITIAL_STATE = {
  analysis_result: null,
  analysis_error: null,
  analysis_loading: false,
}
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case STORE_ANALYSIS_RESULT:
      return { ...state, analysis_result: action.payload }
    case CLEAR_ANALYSIS_RESULT:
      return { ...state, analysis_result: null }
    case CLEAR_ANALYSIS_STRING_ERROR:
      return { ...state, analysis_error: null }
    case ANALYSIS_STRING_ERROR:
      return { ...state, analysis_error: action.payload }
    case SHOW_ANALYSIS_LOADING:
      return { ...state, analysis_loading: true }
    case HIDE_ANALYSIS_LOADING:
      return { ...state, analysis_loading: false }
    default:
      return state
  }
}
